import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const Main = () =>
    import( /* webpackChunkName: "main" */ '../views/main/Main.vue')

const Auth = () =>
    import ( /* webpackChunkName: "dialogues" */ '../views/auth/Auth.vue')

const CheckAuth = () =>
    import ( /* webpackChunkName: "dialogues" */ '../views/auth/CheckAuth.vue')

const DownLoad=() =>import('../views/download/downLoad')

const UpLoad=()=>import('../views/download/upLoad')

const DownUpCenter=()=>import('../views/download/downUpCenter')

const Personal=()=>import('../views/personal/personal')

const Index=()=>import('../views/index/index')
const businessCard=()=>import('../views/leadsSource/businessCard')
const companyInfo=()=>import('../views/customerlist/companylistinfo/CompanyListInfo')
const News=()=>import('../views/material/news')
const Authorization=()=>import('../views/leadsSetting/AuthorizationManagement')
const StaffManage=()=>import('../views/staffManage/staffManage')
Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Main,
        children: [
            /*{
                path:'/',
                meta:{title: '统计分析'},
                component:()=>import('../views/index/index'),
                children:[
                    {
                        path:'/index',
                        meta:{title: '首页概览'}
                    },
                    // {
                    //     path:'/workorderinfo',
                    //     name:'/workorderinfo',
                    //     meta:{title:'工单管理'},
                    //     component:()=>import("../views/workorder/workorderinfo/WorkOrderInfo")

                    // },
                    // {
                    //     path:'/groupmanage',
                    //     name:'/groupmanage',
                    //     component:()=>import("../views/workorder/groupmanage/GroupManage")
                    // }
                ]
            },*/
            {
                path: '/',
                name: '/cusomlist',
                meta:{title:'客户中心' },
                component:()=>import('../views/customerlist/CustomerList'),
                children:[
                    {
                        path: '/',
                        redirect: '/customerInfo'
                    },
                    {
                        path: '/customerInfo',
                        meta:{title:'客户中心' },
                        name:'/customerInfo',
                        components: {
                            sideRouter: () => import('../views/customerlist/customerlistfilter/CustomerListFilter'),
                            customerListRouter:()=>import('../views/customerlist/customerlistinfo/CustomerListInfo')
                        }
                    },
                    {
                        path:'/leadsQunInfo',
                        meta:{title:'群管理' },
                        name:'/leadsQunInfo',
                        components:{
                            sideRouter:() => import('../views/leadsList/leadsQunList/leadsQunSide'),
                            customerListRouter:()=>import('../views/leadsList/leadsQunList/leadsQunInfo')
                        },
                    },


                ]

            },
            {
                path: '/leadsSource/businessCard',
                name:'/businessCard',
                meta:{title: "智能名片"},
                component:()=>import('../views/leadsSource/businessCard')
            },
            {
                path: '/index',
                name:'/index',
                meta:{title: "首页概览",},
                component:()=>import('../views/index/index')
            },
            {
                path: '/leadsSource/dynamicCodeStaff',
                name:'/dynamicCodeStaff',
                meta:{title: "员工活码管理"},
                component:()=>import('../views/leadsSource/dynamicCodeStaff')
            },
            {
                path: '/leadsSource/dynamicCodeQun',
                name:'/dynamicCodeQun',
                meta:{title: "群活码管理"},
                component:()=>import('../views/leadsSource/dynamicCodeQun')
            },
            {
                path: '/leadsSource/api',
                name:'/api',
                meta:{title: "API"},
                component:()=>import('../views/leadsSource/api')
            },
            {
                path: '/leadsSetting/tag',
                name:'/tag',
                meta:{title: "标签管理"},
                component:()=>import('../views/leadsSetting/tag')
            },
            {
                path: '/leadsSetting/leadsAssign',
                name:'/leadsAssign',
                meta:{title: "线索分配"},
                component:()=>import('../views/leadsSetting/leadsAssign')
            },
            {
                path: '/leadsSetting/sourceName',
                name:'/sourceName',
                meta:{title: "来源名称"},
                component:()=>import('../views/leadsSetting/sourceName')
            },
            {
                path: '/material',
                name:'/material',
                meta:{title: "素材中心"},
                component:()=>import('../views/material/material')
            },
            {
                path: '/companyInfo',
                name:'/companyInfo',
                meta:{title: "公司管理"},
                component:companyInfo
            },
            {
                path: '/staffManage',
                name:'/staffManage',
                meta:{title: "使用员工管理"},
                component:StaffManage
            },
            {
                path: '/channel',
                name:'/channel',
                meta:{title: "渠道授权"},
                component:()=>import('../views/leadsSetting/channel')
            },
            {
                path:'/authorization',
                name:'/authorization',
                meta: {title: '授权管理'},
                component:Authorization
            },
            {
                path: '/massSend',
                name:'/massSend',
                meta:{title: "群发任务"},
                component:()=>import('../views/fissionMarketing/massSend')
            },
            {
                path: '/wechatSidebar',
                name:'/wechatSidebar',
                meta:{title: "企微侧边栏"},
                component:()=>import('../views/aiAssistant/wechatSidebar.vue')
            },
            {
                path:'/news/:id',
                name:'/news',
                component:News
            },
            {
                path: '/addworkorder',
                name:'/addworkorder',
                meta:{title: '新增工单'},
                component:()=>import('../views/workorder/addworkorder/AddWorkOrder')
            },
            {
                path: '/editworkorder',
                name:'/editworkorder',
                meta:{title: "工单详情"},
                component:()=>import('../views/workorder/editworkorder/EditWorkOrder')
            },


            {
                path: '/customerdetails',
                meta:{title: '客户详情'},
                name:'/customerdetails',
                component:()=>import('../views/customerlist/customerdetails/CustomerDetails'),
                children: [
                    {
                        path: '/editworkorder',
                        name:'/editworkorder',
                        component:()=>import('../views/workorder/editworkorder/EditWorkOrder')
                    },

                ]
            },
            {
                path: '/companydetails',
                name:'/companydetails',
                meta:{title: '公司详情'},
                component:()=>import('../views/customerlist/companydetails/CompayDetails')
            },
            {
                path:"/",
                component:()=>import('../views/defaultorderstatus/DefaultOrderStatus'),
                children: [
                    {
                        path: "/",
                        redirect:'fieldmanagement'
                    },
                    {
                        path: '/fieldmanagement',
                        name: '/fieldmanagement',
                        meta: {title: '字段管理'},
                        component: ()=>import("../views/fieldmanaement/FieldManagement")
                    },
                    {
                        path: '/workordertemlate',
                        name: '/workordertemlate',
                        meta: {title: '工单模板'},
                        component: ()=>import("../views/workordertemplate/WorkOrderTemplate")
                    },
                    {
                        path: '/defaultinfo',
                        name: '/defaultinfo',
                        meta: {title: '跟进状态'},
                        component:()=>import("../views/defaultorderstatus/defaultInfo/DefaultInfo")
                    },
                    /*{
                        path: '/accountManage',
                        name: '/accountManage',
                        meta: {title: '账号管理'},
                        component:()=>import("../views/setting/accountManage/accountManage")
                    },*/
                ],
            },
            {
                path: '/addtemplate',
                name: '/addtemplate',
                meta: {title: '新增工单模板'},
                component:()=>import('../views/workordertemplate/addtemplate/AddTemplate')
            },
            {
                path: 'personal',
                name: '/personal',
                meta: {title: '个人中心'},
                component:Personal
            },
            {
                path: '/',
                meta: {title: '上传下载中心'},
                component:DownUpCenter,
                children: [
                    {
                        path: "/",
                        redirect:'downLoad'
                    },
                    {
                        path:'upLoad',
                        name:'upLoad',
                        meta: {title: '上传中心'},
                        component:UpLoad
                    },
                    {
                        path:'downLoad',
                        name:'downLoad',
                        meta: {title: '下载中心'},
                        component:DownLoad
                    }
                ]
            }

        ]
    },

    {
        path: '/auth',
        component:Auth
    },
    {
        path: '/login',
        name:'CheckAuth',
        component:CheckAuth
    }

];

const router = new VueRouter({
    routes
})
export default router

